import { Add, Subtract } from "@carbon/icons-react";
import cx from "classnames";
import { type FC, useRef } from "react";
import { type AriaButtonOptions, useButton } from "react-aria";

import { type InputNumberProps } from ".";

export const InputNumberButton: FC<
	AriaButtonOptions<"button"> & {
		size: InputNumberProps["size"];
		variant: "increment" | "decrement";
		position: "outside" | "right";
	}
> = ({ size = "sm", variant, position, ...props }) => {
	const ref = useRef<HTMLButtonElement>(null);
	const { buttonProps, isPressed: isPressedState } = useButton(props, ref);
	let iconSize = 16;
	if (size === "md") {
		iconSize = 20;
	} else if (size === "lg") {
		iconSize = 24;
	}

	return (
		<button
			{...buttonProps}
			ref={ref}
			className={cx(
				"px-2",
				"m-px",
				"outline-none",
				"bg-button-normal-secondary-default",
				"hover:bg-button-normal-secondary-hover",
				"focus:bg-button-normal-secondary-focus",
				"active:bg-button-normal-secondary-active",
				"[&>svg]:fill-icon-default",
				"hover:enabled:[&>svg]:fill-icon-hover",
				"active:enabled:[&>svg]:fill-icon-active",
				"focus:enabled:[&>svg]:fill-icon-focus",
				"disabled:[&>svg]:fill-icon-disabled",
				"disabled:bg-tertiary",
				"disabled:cursor-not-allowed",
				isPressedState && "bg-button-normal-secondary-active",
				size === "sm" && "px-2",
				size === "md" || (size === "lg" && "px-3"),

				// position === "outside",
				variant === "decrement" && position === "outside" && "ml-0",
				variant === "increment" && position === "outside" && "mr-0",
				size === "sm" && variant === "increment" && position === "outside" && "rounded-r",
				size === "sm" && variant === "decrement" && position === "outside" && "rounded-l",
				size === "md" &&
					variant === "increment" &&
					position === "outside" &&
					"rounded-r-md",
				size === "md" &&
					variant === "decrement" &&
					position === "outside" &&
					"rounded-l-md",
				size === "lg" &&
					variant === "increment" &&
					position === "outside" &&
					"rounded-r-lg",
				size === "lg" &&
					variant === "decrement" &&
					position === "outside" &&
					"rounded-l-lg",

				// position === "right",
				position === "right" && "mr-0 my-0",
				size === "sm" && position === "right" && "h-[15px]",
				size === "md" && position === "right" && "h-[18px]",
				size === "lg" && position === "right" && "h-[22px]",
				size === "sm" && variant === "increment" && position === "right" && "rounded-tr",
				size === "sm" && variant === "decrement" && position === "right" && "rounded-br",
				size === "md" && variant === "increment" && position === "right" && "rounded-tr-md",
				size === "md" && variant === "decrement" && position === "right" && "rounded-br-md",
				size === "lg" && variant === "increment" && position === "right" && "rounded-tr-lg",
				size === "lg" && variant === "decrement" && position === "right" && "rounded-br-lg"
			)}
		>
			{variant === "decrement" ? <Subtract size={iconSize} /> : <Add size={iconSize} />}
		</button>
	);
};
